var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75033 0.583496C0.879492 0.583496 0.174909 1.296 0.174909 2.16683L0.166992 14.8335C0.166992 15.7043 0.871575 16.4168 1.74241 16.4168H11.2503C12.1212 16.4168 12.8337 15.7043 12.8337 14.8335V5.3335L8.08366 0.583496H1.75033ZM7.29199 6.12516V1.771L11.6462 6.12516H7.29199Z",
    fill: "#0D6EFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFill);
export default __webpack_public_path__ + "static/media/FileFill.d9170c00.svg";
export { ForwardRef as ReactComponent };